import React, { } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Card,
  Button,
} from '@lockerpm/design';

import {
} from '../../../../../components'

import {
} from '../../../../../utils/common'

import {
  DeleteOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

import storeActions from '../../../../../store/actions';

import global from "../../../../../config/global";
import projectServices from "../../../../../services/project";

const DangerZone = (props) => {
  const { t } = useTranslation()
  const selectedWorkspace = useSelector((state) => state.workspace.selectedWorkspace)

  const {
    className = '',
    project = {}
  } = props;

  const handleDelete = () => {
    global.confirm(() => {
      projectServices.remove(project.id).then(async () => {
        global.notification('success', t('notification.success.title'), t('notification.success.project.deleted'));
        global.navigate('PROJECTS', { workspace_id: selectedWorkspace.id })
        global.store.dispatch(storeActions.updateIsFetchProjects(true))
      }).catch((error) => {
        global.pushError(error)
      });
    });
  };

  return (
    <div className={className}>
      <Card
        className="border-danger"
      >
        <div className="flex justify-between">
          <div>
            <div
              className="flex text-danger"
            >
              <InfoCircleOutlined
                className="mr-1"
              />
              <p className="font-bold">
                {t('project_info.danger_zone')}
              </p>
            </div>
            <p className="mt-1">
              {t('project_info.danger_zone_description')}
            </p>
          </div>
          <Button
            type="primary"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete()}
          >
            {t('button.delete')}
          </Button>
        </div>
      </Card>
    </div>
  );
}

export default DangerZone;
